/**
 * @generated SignedSource<<3584899a04f97d7b36b8766f7bb7f630>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ChildRowsPagination$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraIssueEdge";
      } | null | undefined> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ChildRowsPagination_issues" | "getSelectedOptions">;
    };
  };
  readonly " $fragmentType": "ChildRowsPagination";
};
export type ChildRowsPagination$key = {
  readonly " $data"?: ChildRowsPagination$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChildRowsPagination">;
};

import tableBody_issueTableHierarchy_childIssuesPaginationQuery_graphql from './tableBody_issueTableHierarchy_childIssuesPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "issueSearch"
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "options"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "kind": "RootArgument",
      "name": "scope"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    },
    {
      "kind": "RootArgument",
      "name": "viewConfigInput"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": tableBody_issueTableHierarchy_childIssuesPaginationQuery_graphql
    }
  },
  "name": "ChildRowsPagination",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "issueSearch",
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Variable",
                  "name": "fieldSetsInput",
                  "variableName": "fieldSetsInput"
                },
                {
                  "kind": "Variable",
                  "name": "issueSearchInput",
                  "variableName": "issueSearchInput"
                },
                {
                  "kind": "Variable",
                  "name": "options",
                  "variableName": "options"
                },
                {
                  "kind": "Variable",
                  "name": "scope",
                  "variableName": "scope"
                },
                {
                  "kind": "Variable",
                  "name": "viewConfigInput",
                  "variableName": "viewConfigInput"
                }
              ],
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "cursor"
                    },
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ]
                    }
                  ]
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isConditionalFormattingEnabled",
                      "variableName": "isConditionalFormattingEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "isDensityFull",
                      "variableName": "isDensityFull"
                    },
                    {
                      "kind": "Variable",
                      "name": "isEditableSyncLoaded",
                      "variableName": "isEditableSyncLoaded"
                    },
                    {
                      "kind": "Variable",
                      "name": "isInlineEditingEnabled",
                      "variableName": "isInlineEditingEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "isLinkRelationshipFieldEnabled",
                      "variableName": "isLinkRelationshipFieldEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "isRemoteLinkedIssuesEnabled",
                      "variableName": "isRemoteLinkedIssuesEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "isReparentingEnabled",
                      "variableName": "isReparentingEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "isTimelineEnabled",
                      "variableName": "isTimelineEnabled"
                    },
                    {
                      "kind": "Variable",
                      "name": "projectKey",
                      "variableName": "projectKey"
                    },
                    {
                      "kind": "Variable",
                      "name": "projectKeys",
                      "variableName": "projectKeys"
                    },
                    {
                      "kind": "Variable",
                      "name": "shouldQueryHasChildren",
                      "variableName": "shouldQueryHasChildren"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "ChildRowsPagination_issues"
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "getSelectedOptions",
                      "selections": [
                        {
                          "concreteType": "JiraIssueEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "first",
                                  "value": 500
                                }
                              ],
                              "concreteType": "JiraIssueFieldSetConnection",
                              "kind": "LinkedField",
                              "name": "fieldSets",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraIssueFieldSetEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "concreteType": "JiraIssueFieldSet",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        (v2/*: any*/),
                                        {
                                          "concreteType": "JiraIssueFieldConnection",
                                          "kind": "LinkedField",
                                          "name": "fields",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "concreteType": "JiraIssueFieldEdge",
                                              "kind": "LinkedField",
                                              "name": "edges",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "kind": "LinkedField",
                                                  "name": "node",
                                                  "plural": false,
                                                  "selections": [
                                                    (v1/*: any*/),
                                                    {
                                                      "kind": "ScalarField",
                                                      "name": "fieldId"
                                                    },
                                                    (v2/*: any*/),
                                                    {
                                                      "kind": "InlineFragment",
                                                      "selections": [
                                                        {
                                                          "concreteType": "JiraOptionConnection",
                                                          "kind": "LinkedField",
                                                          "name": "selectedOptions",
                                                          "plural": false,
                                                          "selections": [
                                                            {
                                                              "concreteType": "JiraOptionEdge",
                                                              "kind": "LinkedField",
                                                              "name": "edges",
                                                              "plural": true,
                                                              "selections": [
                                                                {
                                                                  "concreteType": "JiraOption",
                                                                  "kind": "LinkedField",
                                                                  "name": "node",
                                                                  "plural": false,
                                                                  "selections": [
                                                                    {
                                                                      "kind": "ScalarField",
                                                                      "name": "id"
                                                                    },
                                                                    {
                                                                      "kind": "ScalarField",
                                                                      "name": "value"
                                                                    }
                                                                  ]
                                                                },
                                                                (v3/*: any*/)
                                                              ]
                                                            }
                                                          ]
                                                        }
                                                      ],
                                                      "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                      "kind": "InlineFragment",
                                                      "selections": [
                                                        {
                                                          "concreteType": "JiraOption",
                                                          "kind": "LinkedField",
                                                          "name": "fieldOption",
                                                          "plural": false,
                                                          "selections": [
                                                            {
                                                              "kind": "ScalarField",
                                                              "name": "optionId"
                                                            }
                                                          ]
                                                        }
                                                      ],
                                                      "type": "JiraSingleSelectField"
                                                    },
                                                    (v3/*: any*/)
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        (v3/*: any*/)
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "storageKey": "fieldSets(first:500)"
                            }
                          ]
                        }
                      ],
                      "argumentDefinitions": []
                    }
                  ]
                },
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "endCursor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "hasPreviousPage"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "startCursor"
                    }
                  ]
                },
                (v3/*: any*/)
              ]
            },
            "action": "THROW",
            "path": "jira.issueSearch"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "7f004c25a1c439aa277ae00a3fd220b3";

export default node;
